module.exports = __webpack_public_path__ + "img/pp1.c526d735.png";